import TotalRowItem from './TotalRowItem';

export default TotalRowItem;
